<template lang="pug">
  <el-button type="primary" class="form-button" :style="'width:'+width" :disabled="disabled" @click="mapShow">{{text}}</el-button>
</template>

<script>
export default {
  name: 'SmartFormButton',
  props: {
    name: String,
    disabled: {
      type: Boolean,
      default: false
    },
    text: String,
    width: String
  },
  computed: {
  },
  methods: {
    mapShow () {
      this.$emit('SmartInput')
    }
  }
}
</script>




// WEBPACK FOOTER //
// SmartButton.vue?bbd77f8e